import { Card, Row, Col, Typography } from "antd";
import { BarChartOutlined, PieChartOutlined } from "@ant-design/icons";
import { StatusBarChart } from "./Chart/StatusBarChart";
import { CompletionDonutChart } from "./Chart/CompletionDonutChart";

const { Title, Text } = Typography;

export const STATUS_COLORS = {
  sobrecumplido: "#00E676", 
  completado: "#009728",
  "en-progreso": "#317EDA", 
  "en-riesgo": "#FFA500", 
  atrasado: "#D72638", 
};

export function ChartsGrid({
  data,
  filters,
  selectedProject,
  selectedPhase,
  onProjectSelect,
  onPhaseSelect,
}) {
  const chartCards = [
    {
      title: "Estado de Tareas",
      icon: <BarChartOutlined style={{ color: "#317EDA" }} />,
      description:
        "Visualiza cuántas tareas están sobrecumplidas, completadas, en progreso, en riesgo o atrasadas.",
      component: (
        <StatusBarChart
          data={data}
          filters={filters}
          statusColors={STATUS_COLORS} 
        />
      ),
    },
    {
      title: "Cumplimiento General",
      icon: <PieChartOutlined style={{ color: "#009728" }} />,
      description:
        "Distribución general de avance de las tareas, incluyendo las sobrecumplidas (más del 100% de progreso).",
      component: (
        <CompletionDonutChart
          data={data}
          filters={filters}
          statusColors={STATUS_COLORS} 
        />
      ),
    },
  ];

  return (
    <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
      {chartCards.map((chart, index) => (
        <Col xs={24} sm={24} md={12} key={index}>
          <Card
            style={{
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              minHeight: 300,
            }}
            title={
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {chart.icon}
                <Title level={5} style={{ margin: 0, color: "#042956" }}>
                  {chart.title}
                </Title>
              </div>
            }
          >
            <Text
              type="secondary"
              style={{ display: "block", marginBottom: 12 }}
            >
              {chart.description}
            </Text>

            <div
              style={{
                width: "100%",
                minHeight: "220px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {chart.component}
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
